import {createAction} from 'web-app/util/redux/famly-app-helpers';

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `LEAVE_REGISTRATION/UPDATE`,
    (personType, personId, startDate, endDate, leaveType, reason) => ({
        personType,
        personId,
        startDate,
        endDate,
        leaveType,
        reason,
    }),
    (personId, personType, startDate, endDate, leaveType) => ({personId, personType, startDate, endDate, leaveType}),
);
